// SavePlugin.js
import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $generateHtmlFromNodes } from '@lexical/html';

const SavePlugin = ({ htmlContentRef }) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerUpdateListener(({ editorState }) => {
      editorState.read(() => {
        const htmlString = $generateHtmlFromNodes(editor, null);
        htmlContentRef.current = htmlString;
        // You can also debug this here
       // console.log('🔄 Updated HTML:', htmlString);
      });
    });
  }, [editor]);

  return null;
};

export default SavePlugin;
